import React, { Component } from 'react'
import { MDBCard, MDBCardBody, MDBCardTitle, MDBCardText, MDBCardHeader, MDBBtn, MDBContainer, MDBCardFooter } from "mdbreact";
import { MDBNavbar, MDBNavbarBrand, MDBNavbarNav, MDBNavbarToggler, MDBCollapse, MDBNavItem, MDBNavLink, MDBIcon } from 'mdbreact';


export default class Power28 extends Component {

  componentWillRecieveProps(nextProps) {
      this.props = nextProps;
  }

  render() {
    return (
	<div class="container white_background">
		<div class="row justify-content-center Concepts_intro no-gutters">
			<div class="col-0 col-sm-0 col-md-0 col-lg-4 col-xl-4 Concepts_intro_title_A ">
			    <p class="Concepts_line2">POWER<br />Month</p>
			    <p class="Concepts_line3">(Power28)</p>
			</div>
			<div class="col Concepts_intro_content justify-content-center">
				<div class="row Concepts_intro_brief justify-content-center no-gutters">
					<p>Power28 is <font style={{color:"#EF4A81"}}>28 consecutive days</font> during which you will enter all of your sleep, meals, snacks, and drinks (no matter how big or small) into the app. </p>
				</div>
				<div class="row">
					<div class="col-7 col-sm-6 col-md-5 col-lg-5 col-xl-5">
						<img src="https://i.ibb.co/8D3SGRK/slice49-3x.png" alt="slice49-3x" border="0" class="power28_calendar_img"/>
					</div>
					<div class="col-7 col-sm-6 col-md-5 col-lg-5 col-xl-5 power28_calendar_notes">
						<p class="calendar_notes_h"><img src="https://i.ibb.co/Y3t2Pvg/slice50-3x.png" alt="slice50-3x" border="0" class="list_style_tri"/> Start from</p>
					    <p class="calendar_notes_p">The first time you open and use the app.</p>
					</div>
				</div>
	    <div class="row">
			<div class="col"></div>
			<div class="col-10 col-sm-9 col-md-8 col-lg-7 col-xl-6">
                <MDBNavLink class="nav-link" to="/powerWeek">
				   <a href="#"  class="Bottom_button_r">
				   <p>What is a Power Week?</p>
				   </a>
                </MDBNavLink>
            </div>
			<div class="col"></div>
		</div>
			</div>
		</div>
	</div>

);
  }
}





// WEBPACK FOOTER //
// ./src/components/Power28.js